import React from 'react';
import { Handle, Position } from 'reactflow';
import { HelpCircle } from 'lucide-react';

const AskQuestionNode = ({ data }) => {
  return (
    <div className="bg-green-100 border-2 border-green-400 rounded-lg p-4 min-w-[200px]">
      <Handle 
        type="target" 
        position={Position.Top} 
        className="!w-4 !h-4 !bg-green-500 !border-2 !border-white"
        style={{ top: -8 }}
      />
      <div className="flex items-center gap-2 mb-2">
        <HelpCircle size={20} className="text-green-600" />
        <div className="font-semibold text-green-900">Ask Question</div>
      </div>
      <div className="text-sm text-green-700 truncate">
        {data.question || 'No question set'}
      </div>
      <Handle 
        type="source" 
        position={Position.Bottom} 
        className="!w-4 !h-4 !bg-green-500 !border-2 !border-white"
        style={{ bottom: -8 }}
      />
    </div>
  );
};

export default AskQuestionNode;
